import { h } from 'preact';
import modalContent from '../constants/modalContent';

export default function ({ onChangeContent }) {
  return (
    <div className="w-modal-email">
      <i className="email-icon" />
      <p className="w-modal-copy">
        Se envió un enlace a su correo electrónico para restablecer su contraseña.
        Si no aparece en unos minutos, verifique su carpeta de spam.
      </p>
      <div>
        <button
          type="button"
          className="w-modal-button"
          onClick={() => onChangeContent(modalContent.SIGN_IN)}
        >
          Regresar a iniciar sesión
        </button>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./components/EmailSentContent.js